var AddBookmarkFailMessage       = require("./AddBookmarkFailMessage"),
    AddBookmarkSuccessMessage    = require("./AddBookmarkSuccessMessage"),
    DeleteBookmarkFailMessage    = require("./DeleteBookmarkFailMessage"),
    DeleteBookmarkSuccessMessage = require("./DeleteBookmarkSuccessMessage"),
    IconButton                   = require("app/ui/IconButton"),
    UserRequiredMessage          = require("./UserRequiredMessage"),
    config                       = require("app/config"),
    frameThrottle                = require("enyo-perf/utils").frameThrottle,
    get                          = require("object-path").get,
    icons                        = require("app/theme/icons"),
    kind                         = require("enyo/kind"),
    logger                       = require("enyo/logger");

require("app/Bookmarks/BookmarkButton.less");
require("app/theme/IconButton--neutral.less");
require("app/theme/IconButton--neutral-ghost.less");

module.exports = kind(/** @lends  app.Bookmarks.BookmarkButton.prototype */ {

    /**
     * @private
     */
    name: "app.Bookmarks.BookmarkButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-bookmarks-bookmark-button",

    /**
     * @private
     */
    theme: "neutral-ghost",

    /**
     * @type  {string}
     * @public
     */
    loadingCaption: "app.Bookmarks.BookmarkButton.loadingCaption",

    /**
     * @type  {string}
     * @public
     */
    addCaption: "app.Bookmarks.BookmarkButton.addCaption",

    /**
     * @type  {string}
     * @public
     */
    addingCaption: "app.Bookmarks.BookmarkButton.addingCaption",

    /**
     * @type  {string}
     * @public
     */
    removeCaption: "app.Bookmarks.BookmarkButton.removeCaption",

    /**
     * @type  {string}
     * @public
     */
    removingCaption: "app.Bookmarks.BookmarkButton.removingCaption",

    /**
     * @type  {string}
     * @public
     */
    loadingTooltip: "app.Bookmarks.BookmarkButton.loadingTooltip",

    /**
     * @type  {string}
     * @public
     */
    addTooltip: "app.Bookmarks.BookmarkButton.addTooltip",

    /**
     * @type  {string}
     * @public
     */
    addingTooltip: "app.Bookmarks.BookmarkButton.addingTooltip",

    /**
     * @type  {string}
     * @public
     */
    removeTooltip: "app.Bookmarks.BookmarkButton.removeTooltip",

    /**
     * @type  {string}
     * @public
     */
    removingTooltip: "app.Bookmarks.BookmarkButton.removingTooltip",

    /**
     * @type  {string}
     * @public
     */
    loadingIcon: icons["app.Bookmarks.BookmarkButton.loading"],

    /**
     * @type  {string}
     * @public
     */
    unbookmarkIcon: icons["app.Bookmarks.BookmarkButton.unbookmark"],

    /**
     * @type  {string}
     * @public
     */
    bookmarkIcon: icons["app.Bookmarks.BookmarkButton.bookmark"],

    /**
     * The mediaItem
     *
     * @type  {?Object}
     * @public
     */
    mediaItem: null,

    /**
     * @public
     */
    showCaption: true,

    /**
     * @public
     */
    showToast: true,

    /**
     * @private
     */
    isRemovingBookmark: false,

    /**
     * @private
     */
    isAddingBookmark: false,

    /**
     * @private
     */
    addBookmarkFailMessage: null,

    /**
     * @private
     */
    deleteBookmarkFailMessage: null,

    /**
     * @private
     */
    observers: {
        update: ["mediaItem", "showCaption", "isAddingBookmark", "isRemovingBookmark"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            var bookmarkService = this.app.$.bookmarkService;

            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.observe("app.$.bookmarkService.isLoading", this.update);
            this.observe("app.$.i18nService.translation", this.update);
            bookmarkService.on("BookmarkService::updated", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var $authService       = this.app.$.authService,
            $i18nService       = this.app.$.i18nService,
            $bookmarkService   = this.app.$.bookmarkService,
            mediaItem          = this.get("mediaItem") || null,
            showCaption        = this.get("showCaption"),
            isAddingBookmark   = this.get("isAddingBookmark"),
            isRemovingBookmark = this.get("isRemovingBookmark"),
            bookmark;

        // No media item or bookmarking not supported for this media type
        if (!mediaItem
            || !get(config, "bookmarks.enabled", false)
            || get(config, "bookmarks.contentTypes", []).indexOf(mediaItem.type) === -1
        ) {
            this.hide();

            return;
        }

        // Bookmarks are still loading or user is still authenticating
        if ($bookmarkService.isLoading || $authService.isLoggedIn === 0) {
            // Css flags
            !this.hasClass("loading") && this.addClass("loading");

            while (this.hasClass("active")) {
                this.removeClass("active");
            }

            // Content
            this.set("icon", this.loadingIcon);
            this.set("caption", showCaption ? $i18nService.getString(this.get("loadingCaption")) : null);
            this.setAttribute("title", $i18nService.getString(this.get("loadingTooltip")));
        }

        // Everyting is loaded
        else {
            // Try to find a bookmark
            bookmark = $bookmarkService.findBookmark(mediaItem);
            this.set("bookmark", bookmark);

            // CSS loading flag
            if (isAddingBookmark || isRemovingBookmark) {
                !this.hasClass("loading") && this.addClass("loading");
            }
            else {
                while (this.hasClass("loading")) {
                    this.removeClass("loading");
                }
            }

            // CSS active flag
            if (bookmark) {
                !this.hasClass("active") && this.addClass("active");
            }
            else {
                while (this.hasClass("active")) {
                    this.removeClass("active");
                }
            }

            // Content for Adding Bookmark state
            if (isAddingBookmark) {
                this.set("icon", this.loadingIcon);
                this.set("caption", showCaption ? $i18nService.getString(this.get("addingCaption")) : null);
                this.setAttribute("title", $i18nService.getString(this.get("addingTooltip")));
            }

            // Content for Removing Bookmark state
            else if (isRemovingBookmark) {
                this.set("icon", this.loadingIcon);
                this.set("caption", showCaption ? $i18nService.getString(this.get("removingCaption")) : null);
                this.setAttribute("title", $i18nService.getString(this.get("removingTooltip")));
            }

            // Content for Bookmarked state
            else if (bookmark) {
                this.set("icon", this.unbookmarkIcon);
                this.set("caption", showCaption ? $i18nService.getString(this.get("removeCaption")) : null);
                this.setAttribute("title", $i18nService.getString(this.get("removeTooltip")));
            }

            // Content for Unbookmarked state
            else {
                this.set("icon", this.bookmarkIcon);
                this.set("caption", showCaption ? $i18nService.getString(this.get("addCaption")) : null);
                this.setAttribute("title", $i18nService.getString(this.get("addTooltip")));
            }
        }

        this.show();
    },

    /**
     * @param  {enyo.Control}  sender  The sender
     * @private
     */
    tap: function(sender) {
        var $authService     = this.app.$.authService,
            $bookmarkService = this.app.$.bookmarkService,
            node             = this.hasNode(),
            senderNode       = sender.hasNode();

        // Tap is not coming from the button itself.
        if (!node || !senderNode || (sender !== this && !node.contains(senderNode))) {
            return;
        }

        // Already busy
        if ($authService.isLoggedIn === 0
            || $bookmarkService.isLoading
            || this.get("isAddingBookmark")
            || this.get("isRemovingBookmark")) {
            return;
        }

        // User required
        if ($authService.isLoggedIn === -1) {
            this.userRequired();

            return;
        }

        // Remove bookmark
        if (this.get("bookmark")) {
            this.removeBookmark();

            return;
        }

        // Add bookmark
        this.addBookmark();
    },

    /**
     * @private
     */
    userRequired: function() {
        var message;

        // Display error message
        message = this.createComponent({
            kind: UserRequiredMessage
        });
        message.render();
        message.requestShow(true, false);
        message.on("hidden", function() {
            message.destroy();
        });
    },

    /**
     * @private
     */
    addBookmark: function() {
        var mediaItem = this.get("mediaItem");

        // No bookmarks loaded yet or no mediaItem supplied
        if (!mediaItem) {
            return;
        }

        // Add bookmark
        this.set("isAddingBookmark", true);
        this.app.$.bookmarkService
            .addBookmark(mediaItem)
            .then(this.bindSafely(function(response) {
                switch (response.status) {
                    case "ok":
                        this.onAddBookmarkSuccess();
                        break;
                    default:
                        this.onAddBookmarkFailed();
                        break;
                }
                this.set("isAddingBookmark", false);
            }))
            .catch(this.bindSafely(function(error) {
                logger.error(error);

                if (typeof Sentry !== "undefined" && error instanceof Error) {
                    Sentry.captureException(error);
                }

                this.onAddBookmarkFailed();
                this.set("isAddingBookmark", false);
            }));
    },

    /**
     * @private
     */
    removeBookmark: function() {
        var bookmark = this.get("bookmark");

        // No bookmarks loaded yet or no mediaItem supplied
        if (!bookmark) {
            return;
        }

        // Remove bookmark
        this.set("isRemovingBookmark", true);
        this.app.$.bookmarkService
            .removeBookmark(bookmark)
            .then(this.bindSafely(function(response) {
                switch (response.status) {
                    case "ok":
                        this.onDeleteBookmarkSuccess();
                        break;
                    default:
                        this.onDeleteBookmarkFailed();
                        break;
                }
                this.set("isRemovingBookmark", false);
            }))
            .catch(this.bindSafely(function(error) {
                logger.error(error);

                if (typeof Sentry !== "undefined" && error instanceof Error) {
                    Sentry.captureException(error);
                }

                this.onDeleteBookmarkFailed();
                this.set("isRemovingBookmark", false);
            }));
    },

    /**
     * @private
     */
    onAddBookmarkSuccess: function() {
        var toast;

        if (this.showToast) {
            toast = this.createComponent({
                kind: AddBookmarkSuccessMessage
            });

            this.hasNode() && toast.render();
        }
    },

    /**
     * @private
     */
    onAddBookmarkFailed: function() {
        var message;

        // Display error message
        message = this.createComponent({
            kind: AddBookmarkFailMessage
        });
        message.render();
        message.requestShow(true, false);
        message.on("hidden", function() {
            message.destroy();
        });
    },

    /**
     * @private
     */
    onDeleteBookmarkSuccess: function() {
        var toast;

        if (this.showToast) {
            toast = this.createComponent({
                kind: DeleteBookmarkSuccessMessage
            });

            this.hasNode() && toast.render();
        }
    },

    /**
     * @private
     */
    onDeleteBookmarkFailed: function() {
        var message;

        if (!this.get("deleteBookmarkFailMessage")) {
            // Display error message
            message = this.createComponent({
                kind: DeleteBookmarkFailMessage
            });
            message.render();
            message.requestShow(true, false);
            this.set("deleteBookmarkFailMessage", message);

            // Remove reference when message is closing, opening up the ability
            // to show a new error message for subsequent failures.
            message.on("hiding", function() {
                this.set("deleteBookmarkFailMessage", null);
            });

            // Don't forget to destroy once fully hidden
            message.on("hidden", function() {
                message.destroy();
            });
        }
    },

    /**
     * @method
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            this.app.$.bookmarkService.off("BookmarkService::updated", this.update);
            sup.apply(this, arguments);
        };
    })

});
